import AppConstants from 'general/constants/AppConstants';
import axiosClient from './axiosClient';
import _ from 'lodash';
import Utils from 'general/utils/Utils';

const chargeStationApi = {
  // lay danh sach tram sac
  getChargeStationList: (params) => {
    const url = '/cs';
    return axiosClient.get(url, { params: Utils.filterParams(params) });
  },

  // lay thong tin chi tiet tram sac
  getChargeStationDetail: (chargeStationId) => {
    const url = `/cs/${chargeStationId}`;
    return axiosClient.get(url);
  },

  // tao tram sac
  createChargeStation: (params) => {
    const url = '/cs/create';
    return axiosClient.post(url, params);
  },

  // cap nhat thong tin tram sac
  updateChargeStation: (chargeStationId, params) => {
    const url = `/cs/${chargeStationId}`;
    return axiosClient.put(url, params);
  },

  // xoa tram sac
  deleteChargeStation: (chargeStationId) => {
    const url = `/cs/${chargeStationId}`;
    return axiosClient.delete(url);
  },

  // an tram sac
  hideChargeStation: (chargeStationId) => {
    const url = `/cs/${chargeStationId}`;
    const params = {
      status: AppConstants.chargeStationStatus.hidden,
    };
    return axiosClient.put(url, params);
  },

  // khoi phuc tram sac
  restoreChargeStation: (chargeStationId) => {
    const url = `/cs/${chargeStationId}`;
    return axiosClient.put(url, {
      status: AppConstants.chargeStationStatus.normal,
    });
  },

  // tam dung tram sac
  stopChargeStation: (chargeStationId, reason, operationalDate) => {
    const url = `/cs/${chargeStationId}`;
    const params = {
      status: AppConstants.chargeStationStatus.stopped,
      reason: !_.isEmpty(reason) ? reason : null,
      operationalDate: !_.isEmpty(operationalDate) ? operationalDate : null,
    };
    return axiosClient.put(url, params);
  },
};

export default chargeStationApi;
